// Re-export shared error handler with portal-specific wrapper
import { 
  getErrorMessage as getSharedErrorMessage,
  shouldLogError,
  getErrorDetails,
  isNetworkError,
  isAuthError,
  isNotFoundError,
  isValidationError,
  isServerError,
} from '@shared/utils';
import { TranslationKeys } from '../i18n/translations/en';

// Portal-specific wrapper that adapts the shared error handler to work with portal translations
export function getErrorMessage(
  error: any,
  translations: TranslationKeys,
  fallbackMessage?: string
): string {
  // Convert portal translations to the format expected by shared error handler
  const errorTranslations = {
    ...translations.errors.api,
    general: translations.errors.general,
  };
  
  return getSharedErrorMessage(error, errorTranslations, fallbackMessage);
}

// Re-export all other utilities directly
export {
  shouldLogError,
  getErrorDetails,
  isNetworkError,
  isAuthError,
  isNotFoundError,
  isValidationError,
  isServerError,
};